import React, { createContext, useContext } from 'react';
import { themes } from './index.js';

const ThemeContext = createContext();

export const ThemeProvider = ({ theme, children }) => {
  const themeConfig = themes[theme] || themes.locality;
  
  React.useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--theme-primary', themeConfig.primary);
    root.style.setProperty('--theme-secondary', themeConfig.secondary);
    root.style.setProperty('--theme-accent', themeConfig.accent);
    root.style.setProperty('--theme-success', themeConfig.success);
    root.style.setProperty('--theme-bg', themeConfig.bg);
    root.style.setProperty('--theme-card-bg', themeConfig.cardBg);
  }, [themeConfig]);
  
  return (
    <ThemeContext.Provider value={themeConfig}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
